"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import ReviewCard from "./ReviewCard";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { useEffect, useRef, useState } from "react";

function Slider({ slides, currentPage }) {
  const [windowWidth, setWindowWidth] = useState(0);
  const swiperRef = useRef(null);

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.slideTo(0);
    }
  }, [currentPage]);

  useEffect(() => {
    // Set initial window width
    setWindowWidth(window.innerWidth);

    // Handle window resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
  }, []);
  return (
    <div className="relative pb-12">
      {" "}
      {/* Added container with padding */}
      <Swiper
        onSwiper={(swiper) => (swiperRef.current = swiper)}
        modules={[Pagination, Autoplay]}
        spaceBetween={36}
        slidesPerView={windowWidth < 768 ? 1.1 : 1.5}
        loop={true}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
          bulletClass:
            "swiper-pagination-bullet h-2 md:!w-12 cursor-pointer rounded-full !bg-teal opacity-100",
          bulletActiveClass: "swiper-pagination-bullet-active !bg-white",
        }}
        breakpoints={{
          500: {
            spaceBetween: 10,
          },
        }}
        className="pb-8" // Added padding to Swiper
      >
        {slides.map((slide, i) => (
          <SwiperSlide key={i}>
            {({ isActive }) => (
              <ReviewCard i={i} rev={slide} isActive={isActive} />
            )}
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Slider;
